// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3K5l_","codeSection":"styles_codeSection__3xSnR","code":"styles_code__5fLVb"};